import { render, staticRenderFns } from "./OrganisationsTable.vue?vue&type=template&id=9850a9ac"
import script from "./OrganisationsTable.vue?vue&type=script&lang=js"
export * from "./OrganisationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports